import { DialogTitle,DialogActions,DialogContent,Button  } from '@mui/material';
import "./DeleteFileDialog.scss";
import { deleteFileKey } from '../../utils/services/lighthouse';

function ConfirmationDialog({setDeleteConfirmationDialog,fileData}: {
    setDeleteConfirmationDialog: (value: boolean) => void; 
    fileData: any;
  }) {

    const handleDeleteFile = async () => {
        await deleteFileKey(fileData.id)
        setDeleteConfirmationDialog(false)
    }

  return (
    <div className="confirmationDialog">
      <DialogTitle>{"Confirm Delete"}</DialogTitle>
      <DialogContent>
          <p>
          Are you sure you want to delete your file {fileData?.fileName}?
          </p>
          <p>
          cid : {fileData.cid}
          </p>
          <DialogActions
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0rem",
              }}
            >
                <p style={{ cursor: 'pointer', fontWeight: 'normal', textDecoration: 'underline' }} onClick={()=>{
                    handleDeleteFile()
                }}>Delete File</p>
                &nbsp;
              <Button style={{fontSize:'0.9rem',padding:'5px 15px', textTransform:'capitalize'}}
              onClick={()=>{setDeleteConfirmationDialog(false)}}
              >{`Keep File`}</Button>
            </DialogActions>
        </DialogContent>
  
    </div>
  );
}

export default ConfirmationDialog;